<template>
  <div class="text-center">
    <a href="/">
      <img alt="Lihavapp logo" class="welcome-logo" src="../assets/logo.svg" />
    </a>

    <div class="welcome-info">
      is an application for all your waist circumference and body weight measurement needs.
    </div>
    <div class="welcome-info-2">
      <span class="welcome-span-dark">application</a> version <b><router-link to="/versionhistory">{{ APPLICATION_VERSION }}</router-link></b></span><br />
      <span class="welcome-span-dark"><i>{{ this.info.user_count }}</i> registered users</span><br />
      <span class="welcome-span-dark"><i>{{ this.info.measurement_count }}</i> measurements</span><br />
      <span class="welcome-span-dark">#bodypositivity</span> </div>
  
  </div>
</template>

<script>
export default {
  name: "Welcome",
  components: {},
  data: function() {
    return {
      info: {}
    };
  },
  created: function() {
    var self = this;
    this.axios
      .get("/info")
      .then(function(response) {
        self.info = response.data;
      })
      .catch(function(error) {
        console.log(error);
      })
      .then(function() {
        // always executed
      });
  }
};
</script>

<style scoped>
.welcome-logo {
  margin-top: 20px;
  margin-bottom: 20px;
}

.welcome-info-2 a {
  color: white;
}

.welcome-span-dark {
  color: white;
  background-color: #111;
  padding-left: 4px;
  padding-right: 4px;
  margin-right: 1em;
}

.welcome-info {
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  font-size: 170%;
  color: #333;
}

.welcome-info-2 {
  padding: 3px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  font-size: 120%;
  color: #333;
  text-align: center;
}
</style>

